"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AuthorizationBearer {
    /**
     * @param {string} header - A bearer authorization header string
     */
    constructor(header) {
        this[Symbol.toStringTag] = 'AuthorizationBearer';
        this._token = AuthorizationBearer.parseHeader(header);
    }
    get token() {
        return this._token;
    }
    static parseHeader(header) {
        const headerSplit = header.split(' ');
        if (headerSplit.length !== 2) {
            throw new Error(`'${header}' is not a valid header.`);
        }
        const type = headerSplit[0];
        if (type !== 'Bearer') {
            throw new Error(`'${type}' type is not supported.`);
        }
        return headerSplit[1];
    }
}
exports.AuthorizationBearer = AuthorizationBearer;
//# sourceMappingURL=authorization-bearer.js.map